export enum ProfilePhotoType {
  Static = 'static',
  Live = 'live',
}

export enum ProfilePhotoLiveStatus {
  Pending = 'pending',
  Ready = 'ready',
  Failed = 'failed',
}

export interface ProfilePhotoModel {
  id: string;
  url: string;
  hash: string;
  type: ProfilePhotoType;
  liveStatus?: ProfilePhotoLiveStatus;
  staticUrl?: string;
}
